<script>
import baseMixin from '@/mixins/baseMixin'
import bookingDetailsMixin from '@/mixins/bookingDetailsMixin'
import BookingDetailsRequestAlert from './booking-details-request-alert.vue'
import BookingDetailsHeaderCard from './booking-details-header-card.vue'
import BookingDetailsClientInfoCard from './booking-details-client-info-card.vue'
import BookingDetailsTabGroup from './booking-details-tab-group.vue'

export default {
  name: 'BookingDetailsContent',
  components: {
    BookingDetailsRequestAlert,
    BookingDetailsHeaderCard,
    BookingDetailsClientInfoCard,
    BookingDetailsTabGroup,
  },
  mixins: [baseMixin, bookingDetailsMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
  computed: {
    showRequestActionAlert() {
      return this.canActionBookingRequest(
        this.booking.status,
        this.booking.location.id
      )
    },
  },
  methods: {
    handleEvent(payload) {
      this.$emit('actionEvent', payload)
    },
  },
}
</script>

<template>
  <div>
    <BookingDetailsRequestAlert
      v-if="showRequestActionAlert"
      :booking="booking"
    />
    <BookingDetailsHeaderCard :booking="booking" @actionEvent="handleEvent" />

    <v-row>
      <v-col cols="12" md="6">
        <BookingDetailsClientInfoCard :booking="booking" />
      </v-col>
    </v-row>

    <BookingDetailsTabGroup :booking="booking" />
  </div>
</template>
